"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_socks_1 = __importDefault(require("react-socks"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Header_1 = __importDefault(require("./styledComponents/Header"));

var TabHeader_1 = __importDefault(require("./styledComponents/TabHeader"));

var TabHeaderIcon_1 = __importDefault(require("./styledComponents/TabHeaderIcon"));

var ActiveTabHeader_1 = __importDefault(require("./styledComponents/ActiveTabHeader"));

var Pane_1 = __importDefault(require("./styledComponents/Pane"));

var Dropdown_1 = __importDefault(require("./styledComponents/Dropdown"));

var Tabs_meta_1 = require("./Tabs.meta");

var mobx_1 = require("mobx");

var Translate_1 = __importDefault(require("../Translate"));

var Grid_1 = __importDefault(require("../Grid/Grid"));

var Tab_1 = __importDefault(require("../Tab/Tab"));

var NAVIGATION_KEYS = [shared_1.KEYS.LEFT_ARROW, shared_1.KEYS.RIGHT_ARROW, shared_1.KEYS.UP_ARROW, shared_1.KEYS.DOWN_ARROW, shared_1.KEYS.HOME, shared_1.KEYS.END];
var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];

var Tabs =
/** @class */
function (_super) {
  __extends(Tabs, _super);

  function Tabs(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Tabs_meta_1.TABS_CATEGORY_KEY;
    _this.componentKey = Tabs_meta_1.TABS_COMPONENT_KEY;
    _this.focusActiveTab = false;
    _this.activeTabs = [];
    _this.onChangeEvents = [];

    _this.assignReferenceToTabElements = function (tabInstance, breakpointIndex, indexOfTab) {
      if (_this.tabElements && _this.tabElements[breakpointIndex]) {
        _this.tabElements[breakpointIndex][indexOfTab] = tabInstance;
      }
    };

    _this.handleKeyDown = function (options) {
      var e = options.e,
          tabsProps = options.tabsProps,
          tabProps = options.tabProps,
          breakpointIndex = options.breakpointIndex;
      var key = e.key;
      var indexOfTriggeringTab = parseInt(e.currentTarget.id, 10);

      if (NAVIGATION_KEYS.indexOf(key) !== -1) {
        e.preventDefault();
        e.stopPropagation();

        _this.handleNavigation(key, indexOfTriggeringTab, breakpointIndex);
      } else if (ACCEPT_KEYS.indexOf(key) !== -1) {
        e.preventDefault();

        _this.setActiveTab(breakpointIndex, {
          index: indexOfTriggeringTab,
          key: tabProps.tabKey,
          label: tabProps.header
        });
      }
    };

    _this.tabElements = _this.initializeTabElementsArray();
    _this.onChangeEvents = _this.initializeOnChangeEvents();
    return _this;
  }

  Object.defineProperty(Tabs.prototype, "activeTabKey", {
    get: function get() {
      return this.activeTabs;
    },
    enumerable: true,
    configurable: true
  });

  Tabs.prototype.initializeTabElementsArray = function () {
    var _this = this;

    return this.breakpoints.reduce(function (tabElements, breakpoint) {
      var props = breakpoint.props;

      if (props) {
        var tabs = _this.getTabs(props);

        tabElements.push(Array.from({
          length: tabs.length
        }));
      }

      return tabElements;
    }, []);
  };

  Tabs.prototype.initializeOnChangeEvents = function () {
    return this.breakpoints.reduce(function (onChangeEvents, breakpoint) {
      var props = breakpoint.props;

      if (props) {
        onChangeEvents.push(props.onChange);
      }

      return onChangeEvents;
    }, []);
  };

  Tabs.prototype.handleNavigation = function (key, currentTabIndex, breakpointIndex) {
    var lastIndex = this.tabElements[breakpointIndex].length - 1;
    var nextIndex = currentTabIndex;

    switch (key) {
      case shared_1.KEYS.LEFT_ARROW:
      case shared_1.KEYS.UP_ARROW:
        nextIndex -= 1;
        break;

      case shared_1.KEYS.RIGHT_ARROW:
      case shared_1.KEYS.DOWN_ARROW:
        nextIndex += 1;
        break;

      case shared_1.KEYS.HOME:
        nextIndex = 0;
        break;

      case shared_1.KEYS.END:
        nextIndex = lastIndex;
        break;

      default:
        break;
    }

    if (nextIndex < 0) {
      nextIndex = lastIndex;
    }

    if (nextIndex > lastIndex) {
      nextIndex = 0;
    }

    this.focusTab(breakpointIndex, nextIndex);
  };

  Tabs.prototype.focusTab = function (breakpointIndex, index) {
    if (this.tabElements && this.tabElements[breakpointIndex] && this.tabElements[breakpointIndex].length - 1 >= index) {
      this.tabElements[breakpointIndex][index].focus();
    }
  };

  Tabs.prototype.getActiveTabIndex = function (breakpointIndex) {
    var activeTabRef = this.activeTabs[breakpointIndex];

    if (activeTabRef) {
      return activeTabRef.index;
    }
  };

  Tabs.prototype.getActiveTabKey = function (breakpointIndex) {
    var activeTabRef = this.activeTabs[breakpointIndex];

    if (activeTabRef && activeTabRef.key) {
      return activeTabRef.key;
    }
  };

  Tabs.prototype.setActiveTab = function (breakpointIndex, tab, disableFocus, logDataLayer) {
    if (disableFocus === void 0) {
      disableFocus = false;
    }

    if (logDataLayer === void 0) {
      logDataLayer = true;
    }

    var activeTabs = mobx_1.toJS(this.activeTabs);
    activeTabs[breakpointIndex] = tab;
    this.activeTabs = activeTabs;
    var onChange = this.onChangeEvents[breakpointIndex];

    if (onChange && logDataLayer) {
      onChange(tab);
    }

    if (!disableFocus) {
      this.focusActiveTab = true;
    }
  };

  Tabs.prototype.setDefaultActiveTab = function (props, breakpointIndex) {
    var active = props.active;
    var label;

    if (this.activeTabs[breakpointIndex] !== undefined) {
      return;
    }

    var tabComponents = this.getTabs(props);

    if (!active && tabComponents.length > 0) {
      var firstTab = this.getTabs(props)[0];
      active = firstTab.tabKey;
      label = firstTab.header;
    }

    var index = tabComponents.findIndex(function (t) {
      return t.tabKey === active;
    });
    this.setActiveTab(breakpointIndex, {
      index: index,
      key: active,
      label: label
    }, true, false);
  };

  Tabs.prototype.isTabActive = function (tab, indexOfTab, breakpointIndex) {
    var activeBreakpointTabRef = this.activeTabs[breakpointIndex];
    return activeBreakpointTabRef.key === tab.tabKey || activeBreakpointTabRef.index === indexOfTab;
  };

  Tabs.prototype.getActiveTab = function (props, breakpointIndex) {
    var _this = this;

    var activeTabs = this.getTabs(props).filter(function (tab, indexOfTab) {
      return _this.isTabActive(tab, indexOfTab, breakpointIndex);
    });

    if (activeTabs && activeTabs.length > 0) {
      return activeTabs[0];
    }
  };

  Tabs.prototype.getActiveTabContent = function (props, breakpointIndex) {
    var activeTab = this.getActiveTab(props, breakpointIndex);

    if (activeTab) {
      return this.getTabContent(activeTab);
    }
  };

  Tabs.prototype.getTabContent = function (tab) {
    var grid = tab.grid,
        content = tab.content;

    if (grid) {
      return react_1.default.createElement(Grid_1.default, __assign({}, grid));
    }

    return content;
  };

  Tabs.prototype.getTabs = function (props) {
    var children = props.children,
        tabComponents = props.tabComponents;

    if (tabComponents) {
      return tabComponents;
    }

    if (children) {
      var tabs = react_1.default.Children.map(children, function (child, index) {
        if (react_1.default.isValidElement(child) && child.type === Tab_1.default) {
          var _a = child.props,
              content = _a.children,
              props_1 = __rest(_a, ["children"]);

          return __assign({
            content: content
          }, props_1);
        }
      });
      return tabs;
    }

    return [];
  };

  Tabs.prototype.getTabHeaders = function (props, breakpointIndex) {
    var _this = this;

    var _a = props.headersMode,
        headersMode = _a === void 0 ? 'tabs' : _a;
    var tabs = this.getTabs(props);

    if (headersMode === 'tabs') {
      return tabs.map(function (tab, indexOfTab) {
        var TabHeaderComponent = _this.isTabActive(tab, indexOfTab, breakpointIndex) ? ActiveTabHeader_1.default : TabHeader_1.default;
        return _this.getTabHeader({
          breakpointIndex: breakpointIndex,
          indexOfTab: indexOfTab,
          TabHeaderComponent: TabHeaderComponent,
          tabProps: tab,
          tabsProps: props
        });
      });
    }

    if (headersMode === 'dropdown') {
      var items = tabs.map(function (tab) {
        var item = {
          label: tab.header || "",
          value: tab.tabKey
        };
        return item;
      });
      var activeTabKey_1 = this.getActiveTabKey(breakpointIndex);
      var dropdownProps = {
        items: items,
        selectedItem: items.find(function (item) {
          return item.value === activeTabKey_1;
        }),
        onChange: function onChange(selection, index) {
          if (index === void 0) {
            index = -1;
          }

          if (!Array.isArray(selection)) {
            _this.setActiveTab(breakpointIndex, {
              index: index,
              key: selection.value,
              label: selection.label
            });
          }
        }
      };
      return react_1.default.createElement(Dropdown_1.default, __assign({}, dropdownProps));
    }

    return null;
  };

  Tabs.prototype.getTabHeader = function (options) {
    var _this = this;

    var TabHeaderComponent = options.TabHeaderComponent,
        tabsProps = options.tabsProps,
        tabProps = options.tabProps,
        breakpointIndex = options.breakpointIndex,
        _a = options.indexOfTab,
        indexOfTab = _a === void 0 ? 0 : _a;
    var header = tabProps.header,
        icon = tabProps.icon,
        tabKey = tabProps.tabKey;
    var iconAlign = icon && icon.align || 'left';
    var tabHeaderProps = {
      id: indexOfTab.toString(),
      key: tabKey,
      role: 'tab'
    }; // if rendering the NormalView, then the tabs are interactable and thus need to keep the breakpoint index in mind

    if (breakpointIndex !== undefined) {
      var isActive = indexOfTab === this.getActiveTabIndex(breakpointIndex);
      tabHeaderProps = __assign(__assign({}, tabHeaderProps), {
        tabIndex: isActive ? 0 : -1,
        onClick: function onClick() {
          return _this.setActiveTab(breakpointIndex, {
            index: indexOfTab,
            key: tabKey,
            label: header
          });
        },
        onKeyDown: function onKeyDown(e) {
          return _this.handleKeyDown({
            e: e,
            tabProps: tabProps,
            tabsProps: tabsProps,
            breakpointIndex: breakpointIndex
          });
        },
        assignTabReference: function assignTabReference(instance) {
          _this.assignReferenceToTabElements(instance, breakpointIndex, indexOfTab);
        }
      });

      if (this.focusActiveTab && isActive) {
        tabHeaderProps = __assign(__assign({}, tabHeaderProps), {
          isFocused: true
        });
        this.focusActiveTab = false;
      }
    }

    return react_1.default.createElement(TabHeaderComponent, __assign({}, tabHeaderProps), icon && iconAlign === 'left' && react_1.default.createElement(TabHeaderIcon_1.default, {
      asset: icon.asset
    }), react_1.default.createElement(Translate_1.default, null, header), icon && iconAlign === 'right' && react_1.default.createElement(TabHeaderIcon_1.default, {
      asset: icon.asset
    }));
  };

  Tabs.prototype.renderFlatView = function (props) {
    var _this = this;

    var className = this.props.className;
    var tabs = this.getTabs(props).map(function (tabProps, indexOfTab) {
      return react_1.default.createElement(Wrapper_1.default, {
        className: className,
        key: tabProps.tabKey
      }, react_1.default.createElement(Header_1.default, null, _this.getTabHeader({
        indexOfTab: indexOfTab,
        tabProps: tabProps,
        tabsProps: props,
        TabHeaderComponent: ActiveTabHeader_1.default
      })), react_1.default.createElement(Pane_1.default, null, _this.getTabContent(tabProps)));
    });
    return tabs;
  };

  Tabs.prototype.renderNormalView = function (props, breakpointIndex) {
    var className = this.props.className;
    var activeTab = this.getActiveTab(props, breakpointIndex);
    var activeTabKey = activeTab && activeTab.tabKey;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Header_1.default, {
      role: "tablist"
    }, this.getTabHeaders(props, breakpointIndex)), react_1.default.createElement(Pane_1.default, {
      role: "tabpanel",
      tabIndex: 0,
      "aria-labelledby": activeTabKey
    }, this.getActiveTabContent(props, breakpointIndex)));
  };

  Tabs.prototype.render = function () {
    var _this = this;

    var breakpoints = this.breakpoints;
    return react_1.default.createElement(react_1.Fragment, null, breakpoints.map(function (breakpoint, breakpointIndex) {
      var props = breakpoint.props;

      if (props) {
        var flatView = breakpoint && breakpoint.props && breakpoint.props.flatView || _this.props.flatView || false;

        var breakpointProps = _this.getBreakpointComponentProps(breakpoint, breakpointIndex);

        _this.setDefaultActiveTab(props, breakpointIndex);

        return react_1.default.createElement(react_socks_1.default, __assign({}, breakpointProps), flatView ? _this.renderFlatView(props) : _this.renderNormalView(props, breakpointIndex));
      }
    }));
  };

  __decorate([mobx_1.observable], Tabs.prototype, "activeTabs", void 0);

  Tabs = __decorate([mobx_react_1.observer], Tabs);
  return Tabs;
}(shared_1.ResponsiveComponentBase);

exports.Tabs = Tabs;
exports.default = shared_1.InjectedStyledComponent(Tabs, Tabs_meta_1.TABS_CATEGORY_KEY, Tabs_meta_1.TABS_COMPONENT_KEY);